module.exports = __webpack_public_path__ + "img/chr_ts_10.3694bc8f.png";